import { SaveOutlined, ReloadOutlined, DownloadOutlined, TableOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useEffect, useMemo, useState } from "react";
import { ContentHeader } from "../../components";
import { toast } from "react-toastify";
import { Button, Checkbox, Col, DatePicker, Divider, Form, InputNumber, Row, Select, Space, Switch, Table, Tabs, Tag } from "antd";
import { arrayCommon, dateCommon, formatVND, formatVNDNoFractionDigit, validateMessages } from '../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { ChiTietTinhThueThangKhongThuongXuyen, DuLieuThueThangKhongThuongXuyenResponse } from '../../models/thue/Thue';
import dayjs, { Dayjs } from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { ColumnsType } from 'antd/es/table';
import { Links } from '@app/helpers/Links';
import { XuatExcelBaoCaoThueTNCN_KTX, layChiTietThueThangKhongThuongXuyen, layDuLieuTinhThueKhongThuongXuyen, luuThueThangKhongThuongXuyen, layDsThueThangTheoNam } from '../../services/thue';
import { layDsThuLaoKCTTheoNam } from '../../services/thulaokhongchuyentrach';
import { layDsPhuCapTGVTheoNam } from '../../services/luong';
import { layDsKhenThuongNhanSuKhac } from '../../services/nhansukhac';
import { layThongTinCauHinhThue } from '../../services/setting';
import ModalTextForm from '../../components/modal/ModalTextForm';

const ChiTietThueThangKhongThuongXuyen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [saveButton, setSaveButton] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [modalForm] = Form.useForm();
    const [dataThueTNCN, setDataThueTNCN] = useState<Array<DuLieuThueThangKhongThuongXuyenResponse>>([]);
    const dispatch = useDispatch();
    const [khoaDieuChinh, setKhoaDieuChinh] = useState<boolean>(false);
    const [idThueThang, setIdThueThang] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [showModalDSNV, setShowModalDSNV] = useState(false);
    const [mucToiThieuTinhThue, setMucToiThieuTinhThue] = useState<number>(2000000);

    const [loaiChuKy, setLoaiChuKy] = useState<number>(1);
    const [quy, setQuy] = useState<number>(1);
    const [nam, setNam] = useState<number>(dayjs().year());

    const [dsKhongThuThueModal, setDsKhongThuThueModal] = useState<number[]>([]);

    const [chiTietTinhThue, setChiTietTinhThue] = useState<ChiTietTinhThueThangKhongThuongXuyen>({
        dsKhenThuong: [],
        dsThuLaoKCT: [],
        dsThuLaoTGV: [],
        dsThueThanhPhan: [],
        dsKhongThuThue: []
    });

    // States options cho từng thành phần
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsKhenThuongNSK, setDsKhenThuongNSK] = useState<Array<any>>([]);
    const [dsThueTamTinh, setDsThueTamTinh] = useState<Array<any>>([]);

    // State namLoc cho từng thành phần
    const [namLocThuLaoKCT, setNamLocThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocPhuCapTGV, setNamLocPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocKhenThuongNSK, setNamLocKhenThuongNSK] = useState<Dayjs | null>(null);
    const [namLocThueTamTinh, setNamLocThueTamTinh] = useState<Dayjs | null>(null);

    const [chiHienThiCoThuNhap, setChiHienThiCoThuNhap] = useState<boolean>(true);
    const [activeSubTab, setActiveSubTab] = useState<string>("");

    // Lấy dữ liệu thành phần tham chiếu theo năm
    const layDsThanhPhanTheoNam = async (nam?: number) => {
        try {
            const [tlkct, pctgv, ktnsk, thueTamTinh] = await Promise.all([
                layDsThuLaoKCTTheoNam(nam),
                layDsPhuCapTGVTheoNam(nam),
                layDsKhenThuongNhanSuKhac(""),
                layDsThueThangTheoNam(nam),
            ]);
            setDsLuongThuLaoKCT(tlkct ?? []);
            setDsLuongPhuCapTGV(pctgv ?? []);
            setDsKhenThuongNSK(ktnsk ?? []);
            setDsThueTamTinh(thueTamTinh ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const handleMucToiThieuChange = (val: number | null) => {
        const newMuc = (val !== null && val !== undefined && val >= 0) ? val : 0;
        setMucToiThieuTinhThue(newMuc);
        setChiTietTinhThue(prev => ({ ...prev, mucToiThieu: newMuc }));
        form.setFieldsValue({ mucToiThieu: newMuc });

        // Tự động tính lại thuế cho từng dòng theo mức tối thiểu mới
        if (dataThueTNCN && dataThueTNCN.length > 0) {
            const dsKhongThuSet = new Set(chiTietTinhThue.dsKhongThuThue || []);
            const updated = dataThueTNCN.map(item => {
                if (!item.dynamicColumns || item.dynamicColumns.length === 0) {
                    return item;
                }
                const updatedCols = item.dynamicColumns.map(col => {
                    const isKhongThu = dsKhongThuSet.has(col.idKhoanThuNhap) || col.khongThuThue;
                    const thue = (!isKhongThu && col.mucThuNhap >= newMuc)
                        ? Math.round(col.mucThuNhap * 0.1)
                        : 0;
                    return {
                        ...col,
                        soTienThuePhaiDong: thue
                    };
                });
                const tongThue = updatedCols.reduce((sum, col) => sum + (col.soTienThuePhaiDong || 0), 0);
                return {
                    ...item,
                    dynamicColumns: updatedCols,
                    thuePhaiNop: tongThue
                };
            });
            setDataThueTNCN(updated);
        }
    };

    const handleOpenModalThamChieu = async () => {
        setNamLocThuLaoKCT(null);
        setNamLocPhuCapTGV(null);
        setNamLocKhenThuongNSK(null);
        setNamLocThueTamTinh(null);

        modalForm.setFieldsValue({
            mucToiThieu: mucToiThieuTinhThue,
            dsIdThuLaoKCT: chiTietTinhThue.dsThuLaoKCT || [],
            dsIdPhuCapTGV: chiTietTinhThue.dsThuLaoTGV || [],
            dsIdKhenThuongNSK: chiTietTinhThue.dsKhenThuong || [],
            dsIdThueTamTinh: chiTietTinhThue.dsThueThanhPhan || [],
        });
        setDsKhongThuThueModal(chiTietTinhThue.dsKhongThuThue || []);

        dispatch(showLoadingScreen());
        await layDsThanhPhanTheoNam(undefined);
        dispatch(hideLoadingScreen());
        setShowModalDSNV(true);
    };

    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        setListFn: React.Dispatch<React.SetStateAction<any[]>>,
        fetchFn: (nam?: number) => Promise<any[]>,
        filterFn?: (item: any) => boolean
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        try {
            const rawData = await fetchFn(date ? date.year() : undefined);
            const filteredData = filterFn ? (rawData ?? []).filter(filterFn) : (rawData ?? []);
            const currentSelected = modalForm.getFieldValue(fieldName);
            const selectedIds: number[] = Array.isArray(currentSelected)
                ? currentSelected
                : (currentSelected != null ? [currentSelected] : []);
            const selectedSet = new Set(selectedIds);

            setListFn(prevList => {
                const map = new Map<number, any>();
                filteredData.forEach(item => {
                    if (item && item.id != null) map.set(item.id, item);
                });
                (prevList ?? []).forEach(item => {
                    if (item && item.id != null && selectedSet.has(item.id) && !map.has(item.id)) {
                        map.set(item.id, item);
                    }
                });
                return Array.from(map.values());
            });
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const onFinishModalThamChieu = async (values: any) => {
        const mucToiThieuVal = values?.mucToiThieu !== undefined && values?.mucToiThieu !== null
            ? values.mucToiThieu
            : mucToiThieuTinhThue;

        setMucToiThieuTinhThue(mucToiThieuVal);
        form.setFieldsValue({ mucToiThieu: mucToiThieuVal });

        const newChiTiet: ChiTietTinhThueThangKhongThuongXuyen = {
            dsKhenThuong: (values?.dsIdKhenThuongNSK ?? []) as number[],
            dsThuLaoKCT: (values?.dsIdThuLaoKCT ?? []) as number[],
            dsThuLaoTGV: (values?.dsIdPhuCapTGV ?? []) as number[],
            dsThueThanhPhan: (values?.dsIdThueTamTinh ?? []) as number[],
            dsKhongThuThue: dsKhongThuThueModal,
            mucToiThieu: mucToiThieuVal,
        };

        setChiTietTinhThue(newChiTiet);
        setShowModalDSNV(false);

        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            const rs = await layDuLieuTinhThueKhongThuongXuyen(newChiTiet);
            setDataThueTNCN(rs);
            setSaveButton(true);
            toast.success("Tải dữ liệu tính thuế thành công!");
        } catch (err: any) {
            toast.error(err?.message || 'Có lỗi xảy ra khi tải dữ liệu tính thuế.');
            setSaveButton(false);
        }
        dispatch(hideLoadingScreen());
        setIsLoading(false);
    };

    const eventSaveThueKhongThuongXuyen = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                const namVal = loaiChuKy === 2 ? (form.getFieldValue('nam')?.year() || nam) : form.getFieldsValue(['thoiGianThueThang']).thoiGianThueThang.$y;
                const thangVal = loaiChuKy === 2 ? 0 : (form.getFieldsValue(['thoiGianThueThang'])?.thoiGianThueThang?.$M + 1);
                const quyVal = loaiChuKy === 2 ? (form.getFieldValue('quy') || quy) : 0;

                var request = {
                    idThueThang: idThueThang,
                    loaiChuKy: loaiChuKy,
                    quy: quyVal,
                    nam: namVal,
                    thang: thangVal,
                    mucToiThieu: mucToiThieuTinhThue,
                    dsThues: dataThueTNCN,
                    khoaDieuChinh: khoaDieuChinh === true ? 1 : 0,
                    dsKhenThuong: chiTietTinhThue.dsKhenThuong,
                    dsThuLaoKCT: chiTietTinhThue.dsThuLaoKCT,
                    dsThuLaoTGV: chiTietTinhThue.dsThuLaoTGV,
                    dsThueThanhPhan: chiTietTinhThue.dsThueThanhPhan,
                    dsKhongThuThue: chiTietTinhThue.dsKhongThuThue,
                };

                const data = await luuThueThangKhongThuongXuyen(request);

                if (data != 0) {
                    const kyName = loaiChuKy === 2 ? `quý ${quyVal}/${namVal}` : `tháng ${thangVal}/${namVal}`;
                    toast.success(`Lưu tính thuế ${kyName} thành công`);
                    if (!khoaDieuChinh) {
                        setSaveButton(true);
                    } else {
                        setSaveButton(false);
                    }
                    setTrangThai(khoaDieuChinh === true ? 1 : 0);
                    setIdThueThang(data);
                    if (idThueThang == 0) {
                        navigate(`${Links.Thue.ChiTietThueKhongThuongXuyen}?id=${data}`);
                    }
                }
            } catch (error: any) {
                toast.error(error?.message || 'Có lỗi xảy ra. Vui lòng thử lại sau.');
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Vui lòng chọn thời gian muốn tính thuế");
        });
    }

    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await XuatExcelBaoCaoThueTNCN_KTX(idThueThang);
            let kyName = loaiChuKy === 2
                ? `Quy_${quy}_${nam}`
                : `Thang_${form.getFieldValue('thoiGianThueThang')?.format('MM_YYYY') || dayjs().format('MM_YYYY')}`;
            let link = document.createElement('a');
            link.download = `BangTongHop_ThueTNCN_KTX_${kyName}.xlsx`;
            let blob = new Blob([response.data], { type: response.data?.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            toast.success("Xuất file Excel thành công!");
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    };

    const layThueThang = async (id: number) => {
        try {
            setIsLoading(true);
            var data = await layChiTietThueThangKhongThuongXuyen(id);
            const lck = data.loaiChuKy || 1;
            setLoaiChuKy(lck);
            if (data.mucToiThieu !== undefined && data.mucToiThieu !== null && data.mucToiThieu >= 0) {
                setMucToiThieuTinhThue(data.mucToiThieu);
                form.setFieldsValue({ mucToiThieu: data.mucToiThieu });
            }
            if (lck === 2) {
                setQuy(data.quy || 1);
                setNam(data.nam || dayjs().year());
                form.setFieldsValue({
                    loaiChuKy: 2,
                    quy: data.quy || 1,
                    nam: dayjs().year(data.nam || dayjs().year())
                });
            } else {
                form.setFieldsValue({
                    loaiChuKy: 1,
                    thoiGianThueThang: dayjs(dateCommon.formatDate(data.thangNam, "MM/yyyy"), "MM/YYYY")
                });
            }

            setChiTietTinhThue({
                dsKhenThuong: data?.chiTietCacKhoan?.dsKhenThuong || [],
                dsThuLaoKCT: data?.chiTietCacKhoan?.dsThuLaoKCT || [],
                dsThuLaoTGV: data?.chiTietCacKhoan?.dsThuLaoTGV || [],
                dsThueThanhPhan: data?.chiTietCacKhoan?.dsThueThanhPhan || [],
                dsKhongThuThue: data?.chiTietCacKhoan?.dsKhongThuThue || [],
                mucToiThieu: data.mucToiThieu,
            });
            setTrangThai(data?.khoaDieuChinh);

            setDataThueTNCN(data.dataChiTietThueThangResponses);
            if (data?.khoaDieuChinh == 0) {
                setSaveButton(true);
            }
        } catch (e) {
            toast.error("Không thể lấy thông tin bảng tính thuế");
        }
        setIsLoading(false);
    }

    // Helper render 1 row chọn thành phần (năm lọc + select multiple + cờ tạm thu 10% nếu có người đạt mức tối thiểu)
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[],
        rawList?: Array<any>
    ) => {
        const selectedIds: number[] = modalForm.getFieldValue(fieldName) || [];
        const itemsWithMucToiThieu = (rawList || []).filter(item => selectedIds.includes(item.id) && item.coNguoiDatMucToiThieu);

        return (
            <div style={{ marginBottom: 12 }}>
                <Row gutter={8}>
                    <Col span={8}>
                        <Form.Item label={`Năm ${label}`} style={{ marginBottom: 0 }}>
                            <DatePicker
                                changeOnBlur={true}
                                picker="year"
                                placeholder="Năm (để trống = tất cả)"
                                style={{ width: "100%" }}
                                value={namLoc}
                                onChange={onChangeNam}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={16}>
                        <Form.Item label={label} name={fieldName} style={{ marginBottom: 0 }}>
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder={`Chọn ${label.toLowerCase()}`}
                                options={options}
                                notFoundContent="Không có dữ liệu"
                                onChange={() => {
                                    setDsKhongThuThueModal(prev => [...prev]);
                                }}
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {itemsWithMucToiThieu.length > 0 && (
                    <Row gutter={8} style={{ marginTop: 6, paddingLeft: 8 }}>
                        <Col span={24}>
                            <Space wrap direction="horizontal">
                                {itemsWithMucToiThieu.map(item => {
                                    const isKhongThu = dsKhongThuThueModal.includes(item.id);
                                    return (
                                        <Checkbox
                                            key={`khongthu_${item.id}`}
                                            checked={!isKhongThu}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setDsKhongThuThueModal(dsKhongThuThueModal.filter(x => x !== item.id));
                                                } else {
                                                    setDsKhongThuThueModal([...dsKhongThuThueModal, item.id]);
                                                }
                                            }}
                                        >
                                            <span style={{ fontSize: '13px' }}>
                                                Tạm thu 10% thuế cho: <b style={{ color: '#1890ff' }}>{item.ten}</b>
                                            </span>
                                        </Checkbox>
                                    );
                                })}
                            </Space>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    const optionsThuLaoKCT = dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten }));
    const optionsPhuCapTGV = dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten }));
    const optionsKhenThuongNSK = dsKhenThuongNSK.map(x => ({ value: x.id, label: x.ten }));
    const optionsThueTamTinh = dsThueTamTinh.map(x => ({ value: x.id, label: x.tenKyThue }));

    // Lấy danh sách tên các khoản chi thu nhập
    const listPaymentNames = useMemo(() => {
        const names: string[] = [];
        (dataThueTNCN || []).forEach(record => {
            record?.dynamicColumns?.forEach(col => {
                if (col?.tenThuNhap && !names.includes(col.tenThuNhap)) {
                    names.push(col.tenThuNhap);
                }
            });
        });
        return names;
    }, [dataThueTNCN]);

    // Cột của bảng tổng hợp
    const columnsTongHop: ColumnsType<DuLieuThueThangKhongThuongXuyenResponse> = useMemo(() => {
        return [
            {
                title: 'STT',
                key: 'stt',
                width: 60,
                align: 'center',
                fixed: 'left',
                render: (_: any, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    if (!record.idNhanVien || record.idNhanVien === 0) return null;
                    const validEmps = (dataThueTNCN || []).filter(x => x.idNhanVien && x.idNhanVien > 0);
                    const empIdx = validEmps.findIndex(x => x.idNhanVien === record.idNhanVien);
                    return empIdx >= 0 ? empIdx + 1 : null;
                }
            },
            {
                title: 'Họ và tên',
                dataIndex: 'hoTen',
                key: 'hoTen',
                fixed: 'left',
                width: 220,
                render: (text: string, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{text}</span>;
                    }
                    return text;
                }
            },
            {
                title: 'Chức vụ',
                dataIndex: 'tenChucVu',
                key: 'tenChucVu',
                fixed: 'left',
                width: 160,
                render: (text: string, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    if (record.idNhanVien === 0) return null;
                    return text;
                }
            },
            ...listPaymentNames.map((tenThuNhap) => ({
                title: tenThuNhap,
                dataIndex: `col_${tenThuNhap}`,
                key: `col_${tenThuNhap}`,
                align: 'right' as const,
                width: 150,
                className: 'custom-column',
                render: (_: any, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    const item = record?.dynamicColumns?.find((i) => i?.tenThuNhap === tenThuNhap);
                    const val = item ? item.mucThuNhap : undefined;
                    return formatVND(val);
                },
            })),
            {
                title: 'Tổng thu nhập chịu thuế',
                dataIndex: 'tongThuNhapChiuThue',
                key: 'tongThuNhapChiuThue',
                align: 'right',
                width: 160,
                fixed: 'right',
                className: 'custom-column',
                render: (text: number, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    if (record.idNhanVien === 0) {
                        const sumGroup = record?.dynamicColumns?.reduce((acc, curr) => acc + (curr.mucThuNhap || 0), 0) || text;
                        return <span style={{ fontWeight: 'bold' }}>{formatVND(sumGroup)}</span>;
                    }
                    return <span style={{ fontWeight: 600 }}>{formatVND(text)}</span>;
                },
            },
            {
                title: 'Thuế TNCN',
                dataIndex: 'thuePhaiNop',
                key: 'thuePhaiNop',
                align: 'right',
                width: 130,
                fixed: 'right',
                className: 'custom-column',
                render: (text: number, record: DuLieuThueThangKhongThuongXuyenResponse) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold', color: '#ff4d4f' }}>{formatVND(text || 0)}</span>;
                    }
                    return <span style={{ fontWeight: 600, color: '#ff4d4f' }}>{formatVND(text?.toFixed(0) || 0)}</span>;
                },
            }
        ];
    }, [listPaymentNames, dataThueTNCN]);

    const handleToggleKhongThu = (tenKhoan: string, khongThu: boolean) => {
        let idKhoan = 0;
        for (const r of dataThueTNCN) {
            const col = r.dynamicColumns?.find(c => c.tenThuNhap === tenKhoan);
            if (col && col.idKhoanThuNhap) {
                idKhoan = col.idKhoanThuNhap;
                break;
            }
        }

        let newDsKhongThu = [...(chiTietTinhThue.dsKhongThuThue || [])];
        if (idKhoan > 0) {
            if (khongThu) {
                if (!newDsKhongThu.includes(idKhoan)) {
                    newDsKhongThu.push(idKhoan);
                }
            } else {
                newDsKhongThu = newDsKhongThu.filter(x => x !== idKhoan);
            }
        }
        setChiTietTinhThue(prev => ({
            ...prev,
            dsKhongThuThue: newDsKhongThu
        }));

        setDataThueTNCN(prevData => {
            const updated = prevData.map(record => {
                if (record.idNhanVien === 0) return { ...record };
                const newDynamicCols = (record.dynamicColumns || []).map(col => {
                    if (col.tenThuNhap === tenKhoan) {
                        const isColKhongThu = khongThu;
                        const tax = (!isColKhongThu && (col.mucThuNhap || 0) >= mucToiThieuTinhThue)
                            ? Math.round((col.mucThuNhap || 0) * 0.1)
                            : 0;
                        return {
                            ...col,
                            khongThuThue: isColKhongThu,
                            soTienThuePhaiDong: tax
                        };
                    }
                    return col;
                });
                const newThuePhaiNop = newDynamicCols.reduce((sum, col) => sum + (col.soTienThuePhaiDong || 0), 0);
                return {
                    ...record,
                    dynamicColumns: newDynamicCols,
                    thuePhaiNop: newThuePhaiNop
                };
            });

            updated.forEach((item, index) => {
                if (item.idNhanVien === 0) {
                    const nextItems = updated.slice(index + 1);
                    const nextGroupIdx = nextItems.findIndex(n => n.idNhanVien === 0);
                    const groupMembers = nextGroupIdx >= 0 ? nextItems.slice(0, nextGroupIdx) : nextItems;
                    item.thuePhaiNop = groupMembers.reduce((sum, m) => sum + (m.thuePhaiNop || 0), 0);
                }
            });

            return updated;
        });
    };

    // Render bảng chi tiết cho từng khoản
    const renderBangChiTietKhoan = (tenKhoan: string) => {
        let idKhoan = 0;
        for (const r of dataThueTNCN) {
            const col = r.dynamicColumns?.find(c => c.tenThuNhap === tenKhoan);
            if (col && col.idKhoanThuNhap) {
                idKhoan = col.idKhoanThuNhap;
                break;
            }
        }
        const colObjSample = dataThueTNCN.flatMap(r => r.dynamicColumns || []).find(c => c.tenThuNhap === tenKhoan);
        const isKhongThu = Boolean(
            colObjSample?.khongThuThue ||
            (idKhoan > 0 && chiTietTinhThue.dsKhongThuThue?.includes(idKhoan))
        );
        const coNguoiDatMucToiThieu = (dataThueTNCN || []).some(
            r => r.idNhanVien !== 0 && ((r.dynamicColumns?.find(c => c.tenThuNhap === tenKhoan)?.mucThuNhap || 0) >= mucToiThieuTinhThue)
        );

        const rawData = (dataThueTNCN || []).map((record, idx) => {
            const colObj = record.dynamicColumns?.find(c => c.tenThuNhap === tenKhoan);
            const mucThuNhap = colObj?.mucThuNhap || 0;
            const thueTNCN = record.idNhanVien !== 0
                ? (!isKhongThu && mucThuNhap >= mucToiThieuTinhThue ? Math.round(mucThuNhap * 0.1) : 0)
                : 0;
            const thucNhan = mucThuNhap - thueTNCN;
            return {
                key: `khoan_${tenKhoan}_${idx}`,
                idNhanVien: record.idNhanVien,
                hoTen: record.hoTen,
                tenChucVu: record.tenChucVu,
                mucThuNhap,
                thueTNCN,
                thucNhan
            };
        });

        // Tính tổng thuế và thực nhận cho các dòng nhóm (idNhanVien === 0)
        rawData.forEach((item, index) => {
            if (item.idNhanVien === 0) {
                const nextItems = rawData.slice(index + 1);
                const nextGroupIdx = nextItems.findIndex(n => n.idNhanVien === 0);
                const groupMembers = nextGroupIdx >= 0 ? nextItems.slice(0, nextGroupIdx) : nextItems;
                item.thueTNCN = groupMembers.reduce((sum, m) => sum + (m.thueTNCN || 0), 0);
                item.thucNhan = item.mucThuNhap - item.thueTNCN;
            }
        });

        // Lọc hiển thị nhân viên
        const displayData = chiHienThiCoThuNhap
            ? rawData.filter(x => x.idNhanVien !== 0 ? x.mucThuNhap > 0 : true)
            : rawData;

        // Bỏ bớt nhóm rỗng nếu không có nhân viên nào có thu nhập
        const finalData = chiHienThiCoThuNhap
            ? displayData.filter((item, index, arr) => {
                if (item.idNhanVien === 0) {
                    const nextItems = arr.slice(index + 1);
                    const nextGroupIdx = nextItems.findIndex(n => n.idNhanVien === 0);
                    const groupItems = nextGroupIdx >= 0 ? nextItems.slice(0, nextGroupIdx) : nextItems;
                    return groupItems.some(g => g.mucThuNhap > 0);
                }
                return true;
            })
            : displayData;

        const columnsKhoan: ColumnsType<any> = [
            {
                title: 'STT',
                key: 'stt',
                width: 60,
                align: 'center',
                render: (_: any, record: any) => {
                    if (!record.idNhanVien || record.idNhanVien === 0) return null;
                    const validEmps = finalData.filter(x => x.idNhanVien && x.idNhanVien > 0);
                    const empIdx = validEmps.findIndex(x => x.idNhanVien === record.idNhanVien);
                    return empIdx >= 0 ? empIdx + 1 : null;
                }
            },
            {
                title: 'Họ và tên',
                dataIndex: 'hoTen',
                key: 'hoTen',
                render: (text: string, record: any) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{text}</span>;
                    }
                    return text;
                }
            },
            {
                title: 'Chức vụ',
                dataIndex: 'tenChucVu',
                key: 'tenChucVu',
                render: (text: string, record: any) => {
                    if (record.idNhanVien === 0) return null;
                    return text;
                }
            },
            {
                title: 'Thu nhập chịu thuế',
                dataIndex: 'mucThuNhap',
                key: 'mucThuNhap',
                align: 'right',
                render: (text: number, record: any) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold' }}>{formatVND(text)}</span>;
                    }
                    return formatVND(text);
                }
            },
            {
                title: 'Thuế TNCN khấu trừ (10%)',
                dataIndex: 'thueTNCN',
                key: 'thueTNCN',
                align: 'right',
                render: (text: number, record: any) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold', color: '#ff4d4f' }}>{formatVND(text)}</span>;
                    }
                    return <span style={{ color: '#ff4d4f' }}>{formatVND(text)}</span>;
                }
            },
            {
                title: 'Thực nhận',
                dataIndex: 'thucNhan',
                key: 'thucNhan',
                align: 'right',
                render: (text: number, record: any) => {
                    if (record.idNhanVien === 0) {
                        return <span style={{ fontWeight: 'bold', color: '#52c41a' }}>{formatVND(text)}</span>;
                    }
                    return <span style={{ color: '#52c41a', fontWeight: 500 }}>{formatVND(text)}</span>;
                }
            }
        ];

        return (
            <div key={tenKhoan} className="card card-primary mb-3">
                <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f0f5ff', borderBottom: '1px solid #d6e4ff', padding: '10px 16px' }}>
                    <h6 style={{ margin: 0, color: '#1d39c4', fontWeight: 600 }}>
                        📑 Bảng tính thuế chi tiết: {tenKhoan}
                    </h6>
                    <div>
                        {coNguoiDatMucToiThieu ? (
                            <Checkbox
                                checked={!isKhongThu}
                                disabled={trangThai > 0}
                                onChange={(e) => handleToggleKhongThu(tenKhoan, !e.target.checked)}
                            >
                                <span style={{ fontWeight: 600, color: !isKhongThu ? '#1890ff' : '#595959', fontSize: '13px' }}>
                                    Tính tạm thu thuế (10%)
                                </span>
                            </Checkbox>
                        ) : (
                            <Tag color="orange" style={{ margin: 0 }}>
                                Không có nhân sự đạt mức tối thiểu tính thuế ({formatVND(mucToiThieuTinhThue)})
                            </Tag>
                        )}
                    </div>
                </div>
                <div className="card-body p-0">
                    <Table
                        pagination={false}
                        dataSource={finalData}
                        loading={isLoading}
                        columns={columnsKhoan}
                        sticky
                        bordered
                        locale={{ emptyText: "Không có dữ liệu phát sinh" }}
                        rowClassName={(record) => {
                            if (record.idNhanVien === 0) return "bold-row-summary";
                            return "";
                        }}
                        summary={pageData => {
                            let totalThuNhap = 0;
                            let totalThue = 0;
                            let totalThucNhan = 0;

                            pageData.forEach(row => {
                                if (row.idNhanVien !== 0) {
                                    totalThuNhap += (row.mucThuNhap || 0);
                                    totalThue += (row.thueTNCN || 0);
                                    totalThucNhan += (row.thucNhan || 0);
                                }
                            });

                            return (
                                <Table.Summary.Row style={{ backgroundColor: '#fafafa', fontWeight: 'bold' }}>
                                    <Table.Summary.Cell index={0} colSpan={3} align="left">
                                        <label>Tổng cộng ({tenKhoan})</label>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={3} align="right">
                                        <label style={{ color: '#1890ff' }}>{formatVND(totalThuNhap)}</label>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={4} align="right">
                                        <label style={{ color: '#ff4d4f' }}>{formatVND(totalThue)}</label>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={5} align="right">
                                        <label style={{ color: '#52c41a' }}>{formatVND(totalThucNhan)}</label>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            );
                        }}
                    />
                </div>
            </div>
        );
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let id = +(params.get('id') || '');
        setIdThueThang(+id);

        if (!id || id === 0) {
            const state: any = location.state;
            if (state) {
                const lck = state.loaiChuKy || 1;
                setLoaiChuKy(lck);
                if (state.mucToiThieu !== undefined && state.mucToiThieu !== null && state.mucToiThieu >= 0) {
                    setMucToiThieuTinhThue(state.mucToiThieu);
                    form.setFieldsValue({ mucToiThieu: state.mucToiThieu });
                }
                if (lck === 2) {
                    setQuy(state.quy || 1);
                    setNam(state.nam || dayjs().year());
                    form.setFieldsValue({
                        loaiChuKy: 2,
                        quy: state.quy || 1,
                        nam: dayjs().year(state.nam || dayjs().year())
                    });
                } else if (state.thoiGian) {
                    form.setFieldsValue({
                        loaiChuKy: 1,
                        thoiGianThueThang: dayjs(state.thoiGian, 'MM/YYYY')
                    });
                }

                if (state.chiTietTinhThue) {
                    setChiTietTinhThue(state.chiTietTinhThue);
                    (async () => {
                        dispatch(showLoadingScreen());
                        setIsLoading(true);
                        try {
                            const rs = await layDuLieuTinhThueKhongThuongXuyen(state.chiTietTinhThue);
                            setDataThueTNCN(rs);
                            setSaveButton(true);
                        } catch (err: any) {
                            toast.error(err?.message || 'Có lỗi xảy ra khi tải dữ liệu tính thuế.');
                        }
                        dispatch(hideLoadingScreen());
                        setIsLoading(false);
                    })();
                }
            }
        }
    }, [location.state]);

    useEffect(() => {
        const fetchCauHinhThue = async () => {
            try {
                const config = await layThongTinCauHinhThue();
                if (config?.soTienToiThieuTinhThueKTX !== undefined && config?.soTienToiThieuTinhThueKTX >= 0) {
                    if (idThueThang <= 0 && (!location.state || (location.state as any)?.mucToiThieu === undefined)) {
                        setMucToiThieuTinhThue(config.soTienToiThieuTinhThueKTX);
                        form.setFieldsValue({ mucToiThieu: config.soTienToiThieuTinhThueKTX });
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };
        fetchCauHinhThue();
    }, []);

    useEffect(() => {
        if (idThueThang > 0) {
            layThueThang(idThueThang);
        }
    }, [idThueThang]);

    useEffect(() => {
        if (listPaymentNames.length > 0) {
            if (!activeSubTab || !listPaymentNames.includes(activeSubTab)) {
                setActiveSubTab(listPaymentNames[0]);
            }
        }
    }, [listPaymentNames]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 0: tag = (<Tag color="success">Mở khóa</Tag>); break;
        case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
    }

    return (
        <section>
            <ContentHeader title="Thuế thu nhập cá nhân không thường xuyên" />
            <Tabs
                tabBarExtraContent={
                    <Space>
                        {(dataThueTNCN != null && dataThueTNCN.length > 0 && idThueThang > 0) &&
                            <Button
                                loading={isLoading}
                                className="hrm-btn hrm-btn-success"
                                icon={<DownloadOutlined rev="" />}
                                onClick={handleExport}
                            >
                                Xuất excel
                            </Button>
                        }
                        {saveButton ?
                            <Button
                                loading={isLoading}
                                type="primary"
                                icon={<SaveOutlined rev="" />}
                                onClick={eventSaveThueKhongThuongXuyen}
                            >
                                Lưu bảng tính thuế
                            </Button>
                            : null}
                    </Space>
                }
                defaultActiveKey="1"
                items={[
                    {
                        key: "1",
                        label: "Thuế TNCN không thường xuyên",
                        children: (
                            <Row>
                                <Col span="24" className="card card-body">
                                    <Form
                                        layout="vertical"
                                        validateMessages={validateMessages}
                                        form={form}
                                        onFinish={handleOpenModalThamChieu}
                                    >
                                        <Row gutter={12}>
                                            {loaiChuKy === 1 ? (
                                                <Col span={5}>
                                                    <Form.Item
                                                        rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}
                                                        label="Thời gian (Tháng/Năm)"
                                                        name="thoiGianThueThang"
                                                    >
                                                        <DatePicker
                                                            changeOnBlur={true}
                                                            disabled={trangThai >= 0}
                                                            style={{ width: "100%" }}
                                                            format={["MM/YYYY", "MMYYYY"]}
                                                            placeholder="Chọn thời gian"
                                                            picker="month"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            ) : (
                                                <>
                                                    <Col span={3}>
                                                        <Form.Item label="Quý" name="quy" initialValue={quy}>
                                                            <Select
                                                                disabled={trangThai >= 0}
                                                                value={quy}
                                                                onChange={(val) => setQuy(val)}
                                                                options={[
                                                                    { value: 1, label: 'Quý 1' },
                                                                    { value: 2, label: 'Quý 2' },
                                                                    { value: 3, label: 'Quý 3' },
                                                                    { value: 4, label: 'Quý 4' },
                                                                ]}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item label="Năm" name="nam" initialValue={dayjs().year(nam)}>
                                                            <DatePicker
                                                                disabled={trangThai >= 0}
                                                                picker="year"
                                                                style={{ width: "100%" }}
                                                                onChange={(date) => {
                                                                    if (date) setNam(date.year());
                                                                }}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </>
                                            )}
                                            <Col span={5}>
                                                <Form.Item label="Mức tối thiểu tính thuế" name="mucToiThieu" initialValue={mucToiThieuTinhThue}>
                                                    <InputNumber
                                                        disabled={trangThai === 1}
                                                        style={{ width: "100%" }}
                                                        min={0}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value ? Number(value.replace(/\$\s?|(,*)/g, '')) : 0}
                                                        onChange={handleMucToiThieuChange}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            {trangThai >= 0 &&
                                                <Col span={4}>
                                                    <Form.Item label="Trạng thái">
                                                        <label>{tag}</label>
                                                    </Form.Item>
                                                </Col>
                                            }
                                            {(dataThueTNCN != null && dataThueTNCN.length > 0 && saveButton) &&
                                                <Col span={4} style={{ display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                                                    <Checkbox
                                                        checked={khoaDieuChinh}
                                                        onChange={(e) => setKhoaDieuChinh(e.target.checked)}
                                                    >
                                                        Khóa điều chỉnh
                                                    </Checkbox>
                                                </Col>
                                            }
                                        </Row>
                                        <Row>
                                            {trangThai <= 0 &&
                                                <Space>
                                                    <Form.Item>
                                                        <Button
                                                            type="primary"
                                                            className="float-right"
                                                            htmlType="submit"
                                                            loading={isLoading}
                                                            icon={<ReloadOutlined rev="" />}
                                                        >
                                                            Tải dữ liệu tính thuế TNCN
                                                        </Button>
                                                    </Form.Item>
                                                </Space>
                                            }
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        )
                    }
                ]}
            />

            {/* Modal cấu hình các khoản tham chiếu tính thuế */}
            {showModalDSNV && (
                <ModalTextForm
                    title="Cấu hình các khoản tham chiếu tính thuế không thường xuyên"
                    hideFooter
                    show={showModalDSNV}
                    handleClose={() => setShowModalDSNV(false)}
                >
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinishModalThamChieu}
                        form={modalForm}
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Mức thu nhập tối thiểu tính thuế" name="mucToiThieu" rules={[{ required: true, message: 'Vui lòng nhập mức tối thiểu' }]}>
                                    <InputNumber
                                        style={{ width: "100%" }}
                                        min={0}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value ? Number(value.replace(/\$\s?|(,*)/g, '')) : 0}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" style={{ margin: '8px 0 12px 0' }}>
                            <span style={{ color: '#1890ff', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập chịu thuế
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdPhuCapTGV", namLocPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocPhuCapTGV, "dsIdPhuCapTGV", setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam),
                            optionsPhuCapTGV, dsLuongPhuCapTGV)}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdThuLaoKCT", namLocThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocThuLaoKCT, "dsIdThuLaoKCT", setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam),
                            optionsThuLaoKCT, dsLuongThuLaoKCT)}

                        {renderThanhPhanRow("Khen thưởng nhân sự khác", "dsIdKhenThuongNSK", namLocKhenThuongNSK,
                            taoOnChangeNamLoc(setNamLocKhenThuongNSK, "dsIdKhenThuongNSK", setDsKhenThuongNSK, () => layDsKhenThuongNhanSuKhac("")),
                            optionsKhenThuongNSK, dsKhenThuongNSK)}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#722ed1', fontSize: '16px', fontWeight: 'bold' }}>
                                Các khoản thuế thành phần
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Thuế đã tạm tính/tạm thu", "dsIdThueTamTinh", namLocThueTamTinh,
                            taoOnChangeNamLoc(setNamLocThueTamTinh, "dsIdThueTamTinh", setDsThueTamTinh, layDsThueThangTheoNam),
                            optionsThueTamTinh)}

                        <Form.Item style={{ marginTop: 16 }}>
                            <Button type="primary" loading={isLoading} className="float-right" htmlType="submit" icon={<SaveOutlined rev="" />}>
                                Xác nhận & Tính thuế
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            {/* Khu vực hiển thị bảng dữ liệu */}
            <div className="mt-3">
                <Tabs
                    type="card"
                    defaultActiveKey="tong_hop"
                    items={[
                        {
                            key: "tong_hop",
                            label: (
                                <span>
                                    <TableOutlined rev="" /> Bảng tổng hợp
                                </span>
                            ),
                            children: (
                                <div className="card card-primary">
                                    <Table
                                        pagination={false}
                                        dataSource={(dataThueTNCN || []).map((value, index) => ({ key: index, ...value }))}
                                        loading={isLoading}
                                        columns={columnsTongHop}
                                        sticky
                                        bordered
                                        scroll={{ x: 60 + 220 + 160 + listPaymentNames.length * 150 + 160 + 130 }}
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        rowClassName={(record) => {
                                            if (record.idNhanVien === 0) {
                                                return "bold-row-summary";
                                            }
                                            return "";
                                        }}
                                        summary={pageData => {
                                            let totalthuePhaiNop = 0;
                                            let totalTongThuNhapChiuThue = 0;
                                            const dataDynamic: number[] = new Array(listPaymentNames.length).fill(0);

                                            pageData.forEach(({ thuePhaiNop, dynamicColumns, tongThuNhapChiuThue, idNhanVien }) => {
                                                if (idNhanVien !== 0) {
                                                    totalthuePhaiNop += (thuePhaiNop || 0);
                                                    totalTongThuNhapChiuThue += (tongThuNhapChiuThue || 0);

                                                    listPaymentNames.forEach((name, idx) => {
                                                        const item = dynamicColumns?.find((i: any) => i?.tenThuNhap === name);
                                                        if (item && item.mucThuNhap) {
                                                            dataDynamic[idx] += item.mucThuNhap;
                                                        }
                                                    });
                                                }
                                            });

                                            return (
                                                <Table.Summary.Row style={{ backgroundColor: '#fafafa', fontWeight: 'bold' }}>
                                                    <Table.Summary.Cell index={0} colSpan={3} align="left">
                                                        <label>Tổng cộng</label>
                                                    </Table.Summary.Cell>
                                                    {dataDynamic.map((item: number, idx: number) => (
                                                        <Table.Summary.Cell key={"dynamicData_" + idx} index={3 + idx} align="right">
                                                            <label>{formatVND(item)}</label>
                                                        </Table.Summary.Cell>
                                                    ))}
                                                    <Table.Summary.Cell index={3 + listPaymentNames.length} align="right">
                                                        <label style={{ color: '#1890ff' }}>{formatVND(totalTongThuNhapChiuThue) || "-"}</label>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell index={4 + listPaymentNames.length} align="right">
                                                        <label style={{ color: '#ff4d4f' }}>{formatVNDNoFractionDigit(totalthuePhaiNop) || "-"}</label>
                                                    </Table.Summary.Cell>
                                                </Table.Summary.Row>
                                            );
                                        }}
                                    />
                                </div>
                            )
                        },
                        {
                            key: "chi_tiet",
                            label: (
                                <span>
                                    <AppstoreOutlined rev="" /> Chi tiết từng khoản chi ({listPaymentNames.length})
                                </span>
                            ),
                            children: (
                                <div>
                                    <Row className="mb-3 align-items-center" justify="space-between">
                                        <Col>
                                            <Space>
                                                <Switch
                                                    checked={chiHienThiCoThuNhap}
                                                    onChange={setChiHienThiCoThuNhap}
                                                />
                                                <span style={{ fontWeight: 500 }}>Chỉ hiển thị nhân sự có thu nhập</span>
                                            </Space>
                                        </Col>
                                    </Row>

                                    {listPaymentNames.length === 0 ? (
                                        <div className="card card-body text-center text-muted">
                                            Chưa có dữ liệu các khoản chi
                                        </div>
                                    ) : (
                                        <Tabs
                                            type="line"
                                            activeKey={activeSubTab}
                                            onChange={setActiveSubTab}
                                            items={listPaymentNames.map((name) => ({
                                                key: name,
                                                label: name,
                                                children: renderBangChiTietKhoan(name)
                                            }))}
                                        />
                                    )}
                                </div>
                            )
                        }
                    ]}
                />
            </div>
        </section>
    );
};

export default ChiTietThueThangKhongThuongXuyen;